import { createConsumer, Consumer } from '@rails/actioncable'

// Singleton consumer with reference counting so both useWidgetChannel
// and useEndUserChannel share one WebSocket connection.
let sharedConsumer: Consumer | null = null
let refCount = 0
let currentWsUrl: string | null = null

export function getWidgetCable(apiUrl: string): Consumer {
  const url = new URL(apiUrl)
  const wsProtocol = url.protocol === 'https:' ? 'wss:' : 'ws:'
  const wsUrl = `${wsProtocol}//${url.host}/cable`

  // If the URL changed (e.g. after re-init), disconnect old consumer
  if (sharedConsumer && currentWsUrl !== wsUrl) {
    sharedConsumer.disconnect()
    sharedConsumer = null
    refCount = 0
  }

  if (!sharedConsumer) {
    sharedConsumer = createConsumer(wsUrl)
    currentWsUrl = wsUrl
  }

  refCount++
  return sharedConsumer
}

export function releaseWidgetCable(): void {
  refCount--
  if (refCount <= 0) {
    sharedConsumer?.disconnect()
    sharedConsumer = null
    currentWsUrl = null
    refCount = 0
  }
}
